import {QueryClient} from '@tanstack/react-query';

import {ICategory} from 'coreStore/data/categories/types';
import {flattenCategoriesTree} from 'coreUtils/utils';
import CommerceAPI from 'commerceAPI';

export const CATEGORIES_QUERY_KEY = 'categories';

export const getCategoriesQueryKey = (lang: string) => {
	return [CATEGORIES_QUERY_KEY, lang] as const;
};

/**
 * Fetches the full category tree (root, levels 5) and writes it into the
 * shared React Query cache. Returns the flattened record.
 */
export const fetchCategoryTree = async (
	cgid: string,
	commerceApi: CommerceAPI,
	queryClient: QueryClient,
	lang: string,
): Promise<Record<string, ICategory>> => {
	const sharedQueryKey = getCategoriesQueryKey(lang);
	const result = await commerceApi.shopperProducts.getCategory({
		parameters: {id: cgid, levels: 5},
	});

	if (result.isError) {
		return {};
	}

	const flattened = flattenCategoriesTree(result as unknown as ICategory);

	queryClient.setQueryData<Record<string, ICategory>>(sharedQueryKey, (old) => ({
		...(old || {}),
		...flattened,
	}));

	return flattened;
};

export {createCategoryResult} from './createCategoryResult';
export type {ICategoryResult, CategoryDeps} from './createCategoryResult';
